// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__bo1Sp","colCheckbox":"styles_colCheckbox__1O6q2"};